import axios from "axios";
import store from "@/store";
import router from "@/router";
import { Toast } from "vant";
import localStorage from "@/utils/localStorage.js";

const service = axios.create({
  baseURL: "/app/api", // url = base url + request url
  timeout: 10000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    let token = localStorage.get("token");
    if (token != null && token != undefined) {
      config.headers["x-token"] = token.toString().replaceAll('"', "");
    }
    config.headers["x-requested-with"] = "XMLHttpRequest";
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    let temp = JSON.stringify(response).replaceAll("{}", '""');
    response = JSON.parse(temp);
    // const res = response.data;
    const res = response.data.data;

    if (response.data.status == "0") {
      Toast.fail(response.message);
      router.replace({
        //跳转到登录页面
        path: "/loginAuthorization",
        // 将跳转的路由path作为参数，登录成功后跳转到该路由
        query: { redirect: router.currentRoute.fullPath },
      });
      return Promise.reject(res.message || "Error");
    }
    if (res.code == "200") {
      //成功
      return res;
    } else if (res.code == "403") {
      router.replace({
        //跳转到登录页面
        path: "/roleChoices",
        // 将跳转的路由path作为参数，登录成功后跳转到该路由
        query: { redirect: router.currentRoute.fullPath },
      });
      Toast.fail(res.msg);
      return Promise.reject(res.msg || "Error");
    } else {
      Toast.fail(res.msg);
      return res;
    }
  },
  (error) => {
    Toast.fail("网络错误");
    return Promise.reject(error);
  }
);
export default service;
